export enum TabsOverspentDetailsEnum {
    ALL = "ALL" ,
    EXTRAS = "EXTRAS",
    INTERNATIONAL = "INTERNATIONAL",
    PREMIUM = "PREMIUM"
}
